export default __webpack_public_path__ + "static/media/Prize of Zamora.d5fdbd56.jpg";